var render, staticRenderFns
import script from "./FlagCellRenderer.vue?vue&type=script&lang=js"
export * from "./FlagCellRenderer.vue?vue&type=script&lang=js"
import style0 from "./FlagCellRenderer.vue?vue&type=style&index=0&id=5fca08f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fca08f4",
  null
  
)

export default component.exports